<template>
  <div class="vx-row">
    <div class="vx-col">
      <div class="vx-col p-8 vx-card">
        <div class="vx-row ml-4"><span class="title_card">{{$t('generalSettingMenu.btn2')}}</span></div>
        <div class="vx-col">
          <div class="p-2"><span>{{$t('generalSettingMenu.btn2')}}</span></div>
          <div class="vx-row" >
            <div style="width: 10%;display: flex;justify-content: center;"><feather-icon style="height: 40px;width: 40px; display: flex;justify-content: center;border-radius: 5px;background-color: #FCEAEA;color: #EB5757" icon="BellIcon"></feather-icon></div>
            <div style="width: 90%;"><span class="opacity-50">{{$t('generalSettingMenu.textNoti')}}.</span></div>
          </div>
        </div>
      </div>
      <div class="vx-col p-8 pb-16 vx-card mt-4">
        <div class="flex">
          <div class="flex-1 h-12 flex min-col-table">
            <span class="sm:flex hidden m-auto"></span>
          </div>
          <div v-for="item in title" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto" style="font-weight: bold;">{{item}}</span>
          </div>
        </div>
        <div class="flex" style="background-color: #E6F0FD">
          <div class="flex-1 h-12 flex">
            <span class="sm:flex hidden mt-3 ml-3  header-float" style="font-weight: bold;color: #2f80ed;font-size: 15px">{{$t('generalSettingMenu.content')}}</span>
          </div>
          <div v-for="item in title" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto"></span>
          </div>
        </div>
        <div v-for="(p, i) in allPermissions">
          <div class="flex mt-3">
            <div class="flex-1 h-12 flex justify-content-start min-col-table" >
              <span class="sm:flex hidden mt-2  pl-2 header-float">{{p}}</span>
            </div>
            <div v-for="item in title" class="flex-1 h-12 flex">
                <span class="sm:flex hidden m-auto">
                  <feather-icon    icon="CheckIcon" style="width: 1.2rem;color: #2F80ED;"></feather-icon>
                </span>
            </div>
          </div>
        </div>
        <div class="flex mt-3" style="background-color: #E6F0FD">
          <div class="flex-1 h-12 flex">
            <span class="sm:flex hidden mt-3 ml-3  header-float" style="font-weight: bold;color: #2f80ed;font-size: 15px">{{$t('generalSettingMenu.warning')}}</span>
          </div>
          <div v-for="item in title" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto"></span>
          </div>
        </div>
        <div v-for="(p, i) in warning">
          <div class="flex mt-3">
            <div class="flex-1 h-12 flex justify-content-start min-col-table" >
              <span class="sm:flex hidden mt-2 pl-2 header-float">{{p}}</span>
            </div>
            <div v-for="item in title" class="flex-1 h-12 flex">
                <span class="sm:flex hidden m-auto">
                  <feather-icon    icon="CheckIcon" style="width: 1.2rem;color: #2F80ED;"></feather-icon>
                </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Notification",
  data(){
    return{
      title:['Email','Di động','Web(in-app)','Desktop'],
      allPermissions:['Thay đổi liên quan đến tài khoản','Thông báo hết hạn gói dữ liệu','Bản','Báo cáo đã được tạo','Các bản tin từ InfoCare'],
      warning:['Cảnh báo theo thiết lập','Cảnh báo về dữ liệu mới (hàng giờ)','Cảnh báo khi số lượng tin tiêu cực tăng bất thường']
    }
  }
}
</script>

<style scoped>
.title_card{
  font-weight: bold;
  font-size: 28px;
  margin-left: -1rem;
}
.min-col-table {
  min-width: 20rem;
}
</style>
